import React, { useCallback, useState } from "react";
import { API, defaultLimitPagination, get } from "../../config";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserClock } from "@fortawesome/free-solid-svg-icons";
import { Modal } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import Pagination from "./Pagination";
import moment from "moment";
import Spin from "./Spin";
import CustomTooltip from "./CustomTooltip";

const ActivityLogList = ({ id }) => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const defaultPage = query.get("page");
  const defaultLimit = query.get("limit");
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(defaultPage || 1);
  const [limit, setLimit] = useState(defaultLimit || defaultLimitPagination);
  const [total, setTotal] = useState();
  const [from, setFrom] = useState();
  const [to, setTo] = useState();
  const [showActivity, setShowActivity] = useState(false);
  const [activityData, setActivityData] = useState([]);

  const toggleActivityModal = () => {
    if (showActivity) {
      setLimit(defaultLimitPagination);
    } else {
      fetchActivity(1, defaultLimitPagination);
    }
    setShowActivity(!showActivity);
  };

  const fetchActivity = useCallback(
    async (tempPage, tempLimit) => {
      try {
        setLoading(true);
        const { data } = await get(
          `${API.USER_ACTIVITY_LOGS}/${id}?page=${
            tempPage ? tempPage : page ? page : 1
          }&limit=${
            tempLimit ? tempLimit : limit ? limit : defaultLimitPagination
          }`
        );

        setLimit(data?.data?.per_page);
        setPage(data?.data?.current_page);
        setTotal(data?.data?.total);
        setFrom(data?.data?.from);
        setTo(data?.data?.to);
        setActivityData(data?.data?.data);
        setLoading(false);
      } catch (error) {
        if (error?.response?.data?.errors) {
          setLoading(false);
          Object.keys(error?.response?.data?.errors).forEach((key) => {
            toast.error(error?.response?.data?.errors[key][0]);
          });
        } else {
          setLoading(false);
          toast.error(error?.message);
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const handleUpdateLimit = (e) => {
    const limit = e.target.value;
    setLimit(limit);
    setPage(1);
    fetchActivity(1, limit);
  };

  const handleChangePage = (page) => {
    setPage(page);
    fetchActivity(page, limit);
  };

  const activityColumns = [
    {
      dataField: "date",
      text: "Date",
      style: {
        width: "12%",
      },
    },
    {
      dataField: "project_name",
      text: "Project Name",
      style: {
        width: "15%",
      },
    },
    {
      dataField: "name",
      text: "Name",
      style: {
        width: "15%",
      },
    },
    {
      dataField: "email",
      text: "Email",
      style: {
        width: "15%",
      },
    },
    {
      dataField: "activity",
      text: "Activity",
      style: {
        width: "60%",
      },
    },
  ];

  const activityDataGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        key: activityData[i]?.id,
        date: activityData[i]?.created_at
          ? moment(activityData[i]?.created_at, "DD-MM-YYYY HH:mm:ss").format(
              "DD-MM-YYYY HH:mm:ss"
            )
          : null,
        project_name: activityData[i]?.builder_project?.project_name
          ? activityData[i]?.builder_project?.project_name
          : "-",
        name: activityData[i]?.user
          ? activityData[i]?.user?.first_name +
            " " +
            activityData[i]?.user?.last_name
          : "",
        email: activityData[i]?.user?.email ? activityData[i]?.user?.email : "",
        activity: (
          <span
            dangerouslySetInnerHTML={{ __html: activityData[i]?.activity }}
          ></span>
        ),
      });
    }
    return items;
  };
  const activityDatas = activityDataGenerator(activityData?.length);

  return (
    <>
      <CustomTooltip message={"User Activity"}>
        <span>
          <FontAwesomeIcon
            size="1x"
            icon={faUserClock}
            onClick={() => toggleActivityModal()}
          />
        </span>
      </CustomTooltip>
      {showActivity && (
        <Modal
          size="lg"
          show={showActivity}
          onHide={toggleActivityModal}
          dialogClassName="larg-popup journal-modal review-popup small-review doc-variations"
          aria-labelledby="contained-modal-title-vcenter"
          className="project-section"
          centered
        >
          <Modal.Header closeButton>User Activity Log</Modal.Header>
          <Modal.Body style={{ padding: "15px 15px 15px 15px" }}>
            {loading && <Spin />}
            <div className="activity-content" style={{
              maxHeight: "80vh",
              overflow: 'auto'
            }}>
              <BootstrapTable
                keyField="key"
                data={activityDatas}
                columns={activityColumns}
                noDataIndication="No Data Found"
              />
              <Pagination
                total={total}
                limit={parseInt(limit)}
                currentPage={page}
                updateLimit={handleUpdateLimit}
                updatePage={handleChangePage}
                from={from}
                to={to}
              />
            </div>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default ActivityLogList;
